/* =========================================================
   Thomas Markle Jewelers — Bridal 4Cs Tabs
   ========================================================= */
(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('.bridal-fourcs__tab');
    var panels = root.querySelectorAll('.bridal-fourcs__panel');
    if (!tabs.length || !panels.length) return;

    function activate(name) {
      tabs.forEach(function (t) {
        var match = t.dataset.tab === name;
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.tabIndex = match ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.panel === name);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.tab);
      });
      tab.addEventListener('keydown', function (e) {
        var arr = Array.prototype.slice.call(tabs);
        var i = arr.indexOf(tab);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          var next = arr[(i + 1) % arr.length];
          next.focus(); activate(next.dataset.tab);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = arr[(i - 1 + arr.length) % arr.length];
          prev.focus(); activate(prev.dataset.tab);
        } else if (e.key === 'Home') {
          e.preventDefault();
          arr[0].focus(); activate(arr[0].dataset.tab);
        } else if (e.key === 'End') {
          e.preventDefault();
          arr[arr.length - 1].focus(); activate(arr[arr.length - 1].dataset.tab);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bridal-fourcs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Also re-init when Shopify theme editor updates the section
  document.addEventListener('shopify:section:load', function (e) {
    var fourcs = e.target.querySelector('[data-bridal-fourcs]');
    if (fourcs) initTabs(fourcs);
  });
})();
